import { render, staticRenderFns } from "./basic-double-doughnut-visualizer.vue?vue&type=template&id=fc8391f4&scoped=true&"
import script from "./basic-double-doughnut-visualizer.vue?vue&type=script&lang=js&"
export * from "./basic-double-doughnut-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./basic-double-doughnut-visualizer.vue?vue&type=style&index=0&id=fc8391f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8391f4",
  null
  
)

export default component.exports